
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.idb-form-alt {
  margin-bottom: 0.75rem;
  display: block;
  font-weight: var(--fw-semibold);
  color: var(--blue-responsible-darken-1);
}

label {
  display: block;
  width: 100%;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  font-size: var(--fs-xs);
  line-height: var(--lh-xs);
  text-transform: uppercase;
  color: var(--gray-professional-lighten-2);
}

label.form-required:after{
    content:'*';
  }

label.form-required:after {
  float: right;
}

label.form-required:after {
  margin-right: 0.25rem;
}

label.form-required:after {
  color: var(--ui-warningText);
}

input[type='text'], input[type='email'], input[type='url'], input[type='password'], input[type='number'], input[type='date'], input[type='datetime-local'], input[type='month'], input[type='search'], input[type='tel'], input[type='time'], input[type='week'], textarea, select[multiple], select {
  box-sizing: border-box;
  width: 100%;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: var(--neutral-transparent);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-family: Open Sans, Helvetica, Arial, sans-serif;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  line-height: 1.25rem;
  color: var(--blue-responsible-darken-1);
}

@media (min-width: 768px) {

  input[type='text'], input[type='email'], input[type='url'], input[type='password'], input[type='number'], input[type='date'], input[type='datetime-local'], input[type='month'], input[type='search'], input[type='tel'], input[type='time'], input[type='week'], textarea, select[multiple], select {
    width: auto;
  }
}

input[type='text'],
input[type='email'],
input[type='url'],
input[type='password'],
input[type='number'],
input[type='date'],
input[type='datetime-local'],
input[type='month'],
input[type='search'],
input[type='tel'],
input[type='time'],
input[type='week'],
textarea,
select[multiple],
select{

  min-height:40px;
}

input[type='text']::-moz-placeholder, input[type='email']::-moz-placeholder, input[type='url']::-moz-placeholder, input[type='password']::-moz-placeholder, input[type='number']::-moz-placeholder, input[type='date']::-moz-placeholder, input[type='datetime-local']::-moz-placeholder, input[type='month']::-moz-placeholder, input[type='search']::-moz-placeholder, input[type='tel']::-moz-placeholder, input[type='time']::-moz-placeholder, input[type='week']::-moz-placeholder, textarea::-moz-placeholder, select[multiple]::-moz-placeholder, select::-moz-placeholder {
  color: var(--gray-cosmopolitan-main);
}

input[type='text']::placeholder, input[type='email']::placeholder, input[type='url']::placeholder, input[type='password']::placeholder, input[type='number']::placeholder, input[type='date']::placeholder, input[type='datetime-local']::placeholder, input[type='month']::placeholder, input[type='search']::placeholder, input[type='tel']::placeholder, input[type='time']::placeholder, input[type='week']::placeholder, textarea::placeholder, select[multiple]::placeholder, select::placeholder {
  color: var(--gray-cosmopolitan-main);
}

input[type='text']:hover, input[type='email']:hover, input[type='url']:hover, input[type='password']:hover, input[type='number']:hover, input[type='date']:hover, input[type='datetime-local']:hover, input[type='month']:hover, input[type='search']:hover, input[type='tel']:hover, input[type='time']:hover, input[type='week']:hover, textarea:hover, select[multiple]:hover, select:hover {
  border-color: var(--blue-responsible-darken-1);
}

input[type='text']:hover, input[type='email']:hover, input[type='url']:hover, input[type='password']:hover, input[type='number']:hover, input[type='date']:hover, input[type='datetime-local']:hover, input[type='month']:hover, input[type='search']:hover, input[type='tel']:hover, input[type='time']:hover, input[type='week']:hover, textarea:hover, select[multiple]:hover, select:hover {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

input[type='text']:focus, input[type='email']:focus, input[type='url']:focus, input[type='password']:focus, input[type='number']:focus, input[type='date']:focus, input[type='datetime-local']:focus, input[type='month']:focus, input[type='search']:focus, input[type='tel']:focus, input[type='time']:focus, input[type='week']:focus, textarea:focus, select[multiple]:focus, select:focus {
  border-color: var(--blue-responsible-darken-1);
}

input[type='text']:focus, input[type='email']:focus, input[type='url']:focus, input[type='password']:focus, input[type='number']:focus, input[type='date']:focus, input[type='datetime-local']:focus, input[type='month']:focus, input[type='search']:focus, input[type='tel']:focus, input[type='time']:focus, input[type='week']:focus, textarea:focus, select[multiple]:focus, select:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

input[type='text']:focus, input[type='email']:focus, input[type='url']:focus, input[type='password']:focus, input[type='number']:focus, input[type='date']:focus, input[type='datetime-local']:focus, input[type='month']:focus, input[type='search']:focus, input[type='tel']:focus, input[type='time']:focus, input[type='week']:focus, textarea:focus, select[multiple]:focus, select:focus{
    box-shadow:var(--brand-shadow);
  }

input[type='text'].error, input[type='email'].error, input[type='url'].error, input[type='password'].error, input[type='number'].error, input[type='date'].error, input[type='datetime-local'].error, input[type='month'].error, input[type='search'].error, input[type='tel'].error, input[type='time'].error, input[type='week'].error, textarea.error, select[multiple].error, select.error {
  border-color: var(--ui-errorText);
}

select {
  background-repeat: no-repeat;
  padding-right: 3.5rem;
  background-position:top 6px right 12px;
  background-image:url("data:image/svg+xml,%3Csvg width='15' height='8' viewBox='0 0 15 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.81303 7.83121L14.6455 0.979811C14.8692 0.755333 14.8688 0.391897 14.6443 0.167795C14.4198 -0.0561333 14.0562 -0.0555547 13.8323 0.168952L7.40651 6.61254L0.980746 0.16872C0.756818 -0.0557579 0.393412 -0.0563366 0.168904 0.167563C0.0563612 0.279903 8.96267e-05 0.427077 8.96203e-05 0.574251C8.96139e-05 0.721049 0.0559854 0.867644 0.167747 0.979782L7.00003 7.83121C7.10759 7.93933 7.25399 8 7.40651 8C7.55904 8 7.70526 7.93916 7.81303 7.83121Z' fill='%231B365D'/%3E%3C/svg%3E");
}

textarea {
  display: block;
}

input[type='checkbox'], input[type='radio'] {
  float: left;
  margin: 0px;
  box-sizing: border-box;
  cursor: pointer;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-width: 2px;
  border-style: solid;
  border-color: var(--gray-professional-lighten-1);
  outline: 2px solid transparent;
  outline-offset: 2px;

  min-width:1.25rem;
  width:25px;
  height:25px;
  margin-top:-2px;
}

input[type='checkbox'] + label, input[type='radio'] + label {
  margin-bottom: 0px;
}

input[type='checkbox'] + label, input[type='radio'] + label {
  margin-top: 0px;
}

input[type='checkbox'] + label, input[type='radio'] + label {
  display: inline-block;
}

input[type='checkbox'] + label, input[type='radio'] + label {
  cursor: pointer;
}

input[type='checkbox'] + label, input[type='radio'] + label {
  padding-left: 0.75rem;
}

input[type='checkbox'] + label, input[type='radio'] + label {
  color: var(--gray-professional-lighten-1);
}

input[type='checkbox'].error, input[type='radio'].error {
  border-color: var(--ui-errorText);
}

input[type='checkbox'] {
  position: relative;
  border-radius: 0.25rem;
  background-color: var(--neutral-white);
}

input[type='checkbox']:checked {
  position: relative;
}

input[type='checkbox']:checked {
  border-color: var(--blue-responsible-main);
}

input[type='checkbox']:checked {
  background-color: var(--blue-responsible-main);
}

input[type='checkbox']:checked {
  color: var(--neutral-white);
}

input[type='checkbox']:checked::before {
  position: absolute;
}

input[type='checkbox']:checked::before {
  left: 50%;
}

input[type='checkbox']:checked::before {
  top: 50%;
}

input[type='checkbox']:checked::before {
  display: block;
}

input[type='checkbox']:checked::before {
  height: 0.5rem;
}

input[type='checkbox']:checked::before {
  width: 1rem;
}

input[type='checkbox']:checked::before {
  border-width: 1px;
}

input[type='checkbox']:checked::before {
  border-top-width: 0px;
}

input[type='checkbox']:checked::before {
  border-bottom-width: 2px;
}

input[type='checkbox']:checked::before {
  border-left-width: 2px;
}

input[type='checkbox']:checked::before {
  border-right-width: 0px;
}

input[type='checkbox']:checked::before {
  border-style: solid;
}

input[type='checkbox']:checked::before {
  border-color: var(--neutral-white);
}

input[type='checkbox']:checked::before{
      content:'';
      transform:translate(-50%, -60%) rotate(-45deg);
    }

input[type='checkbox'].error:checked {
  border-color: var(--ui-errorText);
}

input[type='checkbox'].error:checked {
  background-color: var(--neutral-white);
}

input[type='checkbox'].error:checked::before {
  border-color: var(--ui-errorText);
}

input[type='radio'] {
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  color: var(--neutral-white);
  outline: 2px solid transparent;
  outline-offset: 2px;
}

input[type='radio']::before {
  display: block;
}

input[type='radio']::before {
  border-radius: 9999px;
}

input[type='radio']::before{

    content:'';
    width:15px;
    height:15px;
  }

input[type='radio']:checked {
  border-color: var(--blue-responsible-main);
}

input[type='radio']:checked::before {
  background-color: var(--blue-responsible-main);
}

input[type='radio'].error:checked {
  border-color: var(--ui-errorText);
}

input[type='radio'].error:checked::before {
  background-color: var(--ui-errorText);
}

input[type='file'] {
  font-size: var(--fs-base);
  line-height: var(--lh-base);
}

fieldset {
  margin: 0px;
  border-style: none;
  padding: 0px;
}

legend {
  margin-bottom: 0.75rem;
  font-weight: var(--fw-semibold);
}

[type='submit'] {
  display: flex;
  cursor: pointer;
  align-items: center;
  border-width: 1px;
  border-style: solid;
  border-color: var(--blue-responsible-main);
  background-color: var(--blue-responsible-main);
  padding-left: 4rem;
  padding-right: 4rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  text-align: center;
  font-family: Open Sans, Helvetica, Arial, sans-serif;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  font-weight: var(--fw-semibold);
  line-height: 1.25;
  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  border-radius:10px;
  color:var(--neutral-white) !important;
}

[type='submit']:hover, [type='submit']:focus {
  cursor: pointer;
}

[type='submit']:hover, [type='submit']:focus {
  background-color: var(--neutral-white);
}

[type='submit']:hover, [type='submit']:focus {
  color: var(--blue-responsible-main);
}

[type='submit']:hover,
  [type='submit']:focus{
    color:var(--blue-responsible-darken-1) !important;
  }

[type='submit'].secondary {
  background-color: var(--neutral-white);
}

[type='submit'].secondary {
  color: var(--blue-responsible-main) !important;
}

[type='submit'].secondary:hover, [type='submit'].secondary:focus {
  cursor: pointer;
}

[type='submit'].secondary:hover, [type='submit'].secondary:focus {
  background-color: var(--blue-responsible-main);
}

[type='submit'].secondary:hover, [type='submit'].secondary:focus {
  color: var(--neutral-white);
}

[type='submit'].secondary:hover, [type='submit'].secondary:focus {
  color: var(--neutral-white) !important;
}

[type='submit'].tertiary {
  border-top-color: var(--green-guarantee-lighten-2);
}

[type='submit'].tertiary {
  background-color: var(--green-guarantee-lighten-3);
}

[type='submit'].tertiary {
  color: var(--neutral-white);
}

[type='submit'].tertiary:hover, [type='submit'].tertiary:focus {
  cursor: pointer;
}

[type='submit'].tertiary:hover, [type='submit'].tertiary:focus {
  background-color: var(--neutral-white);
}

[type='submit'].tertiary:hover, [type='submit'].tertiary:focus {
  color: var(--green-guarantee-darken-2);
}

.form-item-story {
  border-radius: 0.375rem;
  border-width: 1px;
  border-style: solid;
  border-color: var(--gray-professional-lighten-2);
}

.form-item-story:hover {
  border-color: var(--blue-responsible-darken-1);
}

.form-item-story:hover {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.form-item-story input:focus, .form-item-story select:focus, .form-item-story textarea:focus {
  border-width: 0px;
}

.form-item-story input:focus, .form-item-story select:focus, .form-item-story textarea:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.form-item-story .chosen-container-single .chosen-single {
  height: 2.5rem;
}

.form-item-story .chosen-container-single .chosen-single {
  border-width: 0px;
}

.form-item-story .chosen-container-single .chosen-single {
  background-image: none;
}

.form-item-story .chosen-container-single .chosen-single {
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
}

.form-item-story .chosen-container-single .chosen-single {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.form-item-story .chosen-container-single .chosen-single {
  font-family: Open Sans, Helvetica, Arial, sans-serif;
}

.form-item-story .chosen-container-single .chosen-single {
  font-size: var(--fs-base);
  line-height: var(--lh-base);
}

.form-item-story .chosen-container-single .chosen-single {
  font-weight: var(--fw-normal);
}

.form-item-story .chosen-container-single .chosen-single {
  line-height: 1.25rem;
}

.form-item-story .chosen-container-single .chosen-single {
  color: var(--blue-responsible-darken-1);
}

.form-item-story .chosen-container-single .chosen-single {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.form-item-story .chosen-container.form-select{
    background-position:right 12px top 17px;
  }

.form-item-story .form-no-label input[type='text'],
    .form-item-story .form-no-label select{
      padding-top:0px !important;
      padding-bottom:0px !important;
    }

.form-item-story .form-no-label select{
      background-position:top 15px right 12px !important;
    }

.form-item-story input[data-icon],
  .form-item-story input[type='search']{
    padding-right:20px;
  }

.form-item-row .form-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  gap: 1rem;
}

@media (min-width: 768px) {

  .form-item-row .form-actions {
    flex-direction: column;
  }

  .form-item-row .form-actions {
    flex-wrap: wrap;
  }
}

.form-item-row .form-actions [type='submit'] {
  margin-top: 0px;
}

.form-item-row .form-actions [type='submit'] {
  padding-left: 1rem;
  padding-right: 1rem;
}

@media (min-width: 768px) {

  .form-item-row .form-actions--justify-center {
    justify-content: center;
  }
}

.form-item-row .form-actions.space-end {
  justify-content: flex-end;
}

.form-item-row .form-actions.space-end {
  padding-right: 1.5rem;
}

.form-item-row .form-actions.space-between {
  place-content: space-between;
}

.form-item-row .form-actions.space-between {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

input[data-icon],
input[type='search']{
  background-repeat:no-repeat;
  background-position:15px center;
  background-size:20px auto;
  padding-left:50px;
  padding-right:120px;
}

input[data-icon='search'],
input[type='search']{
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z' stroke='%23004E70' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M19 19L14.65 14.65' stroke='%23004E70' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  padding-top:22px;
  padding-bottom:22px;
}

input[data-icon='download']{
  background-image:url("data:image/svg+xml,%3Csvg fill='none' height='20' viewBox='0 0 21 20' width='21' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'%3E%3Cpath d='m17.75 12.5v3.3333c0 .4421-.1756.866-.4882 1.1785-.3125.3126-.7364.4882-1.1785.4882h-11.66663c-.44203 0-.86595-.1756-1.17851-.4882-.31257-.3125-.48816-.7364-.48816-1.1785v-3.3333'/%3E%3Cpath d='m6.08398 8.33398 4.16672 4.16672 4.1666-4.16672'/%3E%3Cpath d='m10.25 12.5v-10'/%3E%3C/g%3E%3C/svg%3E");
}

input[data-icon='download']:hover,
  input[data-icon='download']:focus{
    background-image:url("data:image/svg+xml,%3Csvg fill='none' height='20' viewBox='0 0 21 20' width='21' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%2300374e' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'%3E%3Cpath d='m17.75 12.5v3.3333c0 .4421-.1756.866-.4882 1.1785-.3125.3126-.7364.4882-1.1785.4882h-11.66663c-.44203 0-.86595-.1756-1.17851-.4882-.31257-.3125-.48816-.7364-.48816-1.1785v-3.3333'/%3E%3Cpath d='m6.08398 8.33398 4.16672 4.16672 4.1666-4.16672'/%3E%3Cpath d='m10.25 12.5v-10'/%3E%3C/g%3E%3C/svg%3E");
  }

select[disabled], select[disabled]:hover, input[disabled], input[disabled]:hover, textarea[disabled], textarea[disabled]:hover {
  cursor: not-allowed;
  border-color: var(--gray-cosmopolitan-main);
  background-color: var(--gray-cosmopolitan-lighten-4);
  color: var(--gray-cosmopolitan-darken-1);
}

select[disabled]::-moz-placeholder, select[disabled]:hover::-moz-placeholder, input[disabled]::-moz-placeholder, input[disabled]:hover::-moz-placeholder, textarea[disabled]::-moz-placeholder, textarea[disabled]:hover::-moz-placeholder {
  color: var(--gray-professional-main);
}

select[disabled]::placeholder, select[disabled]:hover::placeholder, input[disabled]::placeholder, input[disabled]:hover::placeholder, textarea[disabled]::placeholder, textarea[disabled]:hover::placeholder {
  color: var(--gray-professional-main);
}

select[disabled]{
  background-image:url("data:image/svg+xml,%3Csvg width='15' height='8' viewBox='0 0 15 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.81303 7.83121L14.6455 0.979811C14.8692 0.755333 14.8688 0.391897 14.6443 0.167795C14.4198 -0.0561333 14.0562 -0.0555547 13.8323 0.168952L7.40651 6.61254L0.980746 0.16872C0.756818 -0.0557579 0.393412 -0.0563366 0.168904 0.167563C0.0563612 0.279903 8.96267e-05 0.427077 8.96203e-05 0.574251C8.96139e-05 0.721049 0.0559854 0.867644 0.167747 0.979782L7.00003 7.83121C7.10759 7.93933 7.25399 8 7.40651 8C7.55904 8 7.70526 7.93916 7.81303 7.83121Z' fill='%23B3B5B8'/%3E%3C/svg%3E");
}

input[type='checkbox'][disabled] + label, input[type='radio'][disabled] + label {
  color: var(--gray-professional-main);
}

input[type='checkbox'][disabled]:checked {
  border-color: var(--gray-cosmopolitan-main);
  background-color: var(--gray-cosmopolitan-main);
}

input[type='radio'][disabled]:checked {
  border-color: var(--gray-cosmopolitan-main);
}

input[type='radio'][disabled]:checked::before {
  background-color: var(--gray-cosmopolitan-main);
}

[type='submit'][disabled] {
  border-color: var(--gray-cosmopolitan-lighten-2);
  background-color: var(--gray-cosmopolitan-lighten-2);
  color: var(--neutral-white);
}

[type='submit'][disabled]:hover, [type='submit'][disabled]:focus {
  border-color: var(--gray-cosmopolitan-lighten-2);
}

[type='submit'][disabled]:hover, [type='submit'][disabled]:focus {
  background-color: var(--gray-cosmopolitan-lighten-2);
}

[type='submit'][disabled]:hover, [type='submit'][disabled]:focus {
  color: var(--neutral-white);
}

[type='submit'][disabled].secondary {
  border-color: var(--gray-cosmopolitan-main);
}

[type='submit'][disabled].secondary {
  background-color: var(--neutral-white);
}

[type='submit'][disabled].secondary {
  color: var(--gray-cosmopolitan-main);
}

[type='submit'][disabled].secondary:hover, [type='submit'][disabled].secondary:focus {
  border-color: var(--gray-cosmopolitan-main);
}

[type='submit'][disabled].secondary:hover, [type='submit'][disabled].secondary:focus {
  color: var(--gray-cosmopolitan-main);
}

input[readonly], textarea[readonly] {
  background-color: var(--gray-cosmopolitan-lighten-4);
}

.form-item {
  width: 100%;
  border-radius: 0.375rem;
  background-color: var(--neutral-white);
}

@media (min-width: 768px) {

  .form-item {
    width: auto;
  }
}

.form-actions {
  margin-top: 2rem;
  margin-bottom: 1.75rem;
  width: 100%;
}

@media (min-width: 768px) {

  .form-actions {
    width: auto;
  }
}

.form-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

@media (min-width: 768px) {

  .form-actions {
    flex-wrap: nowrap;
  }
}

.form-actions{
  gap:1rem;
}

.form-actions [type='submit'] {
  margin-top: 1.75rem;
}

@media (min-width: 768px) {

  .form-actions--justify-center {
    justify-content: center;
  }
}

.form-actions.space-end {
  justify-content: flex-end;
}

.form-actions.space-end {
  padding-right: 1.5rem;
}

.form-actions.space-between {
  place-content: space-between;
}

.form-actions.space-between {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.visually-hidden{
  position:absolute;
  width:1px;
  height:1px;
  padding:0;
  margin:-1px;
  overflow:hidden;
  clip:rect(0, 0, 0, 0);
  white-space:nowrap;
  border-width:0;
}

.single .form-item {
  margin-bottom: 0px;
}

.error-message {
  margin-top: 0.75rem;
  display: flex;
  align-items: center;
  color: var(--ui-errorText);
}

.error-message::before {
  margin-right: 0.5rem;
}

.error-message::before {
  display: block;
}

.error-message::before {
  height: 1.25rem;
}

.error-message::before {
  width: 1.25rem;
}

.error-message::before{
    content:'';
    background-image:url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 1.29032C14.7831 1.29032 18.7097 5.16431 18.7097 10C18.7097 14.8101 14.8141 18.7097 10 18.7097C5.19177 18.7097 1.29032 14.816 1.29032 10C1.29032 5.19343 5.18556 1.29032 10 1.29032ZM10 0C4.47754 0 0 4.47915 0 10C0 15.5241 4.47754 20 10 20C15.5225 20 20 15.5241 20 10C20 4.47915 15.5225 0 10 0ZM9.53669 4.83871H10.4633C10.7384 4.83871 10.9582 5.06782 10.9467 5.34274L10.6645 12.1169C10.6537 12.3761 10.4404 12.5806 10.181 12.5806H9.81895C9.55956 12.5806 9.34629 12.3761 9.33548 12.1169L9.05323 5.34274C9.04181 5.06782 9.26157 4.83871 9.53669 4.83871ZM10 13.3871C9.37645 13.3871 8.87097 13.8926 8.87097 14.5161C8.87097 15.1397 9.37645 15.6452 10 15.6452C10.6235 15.6452 11.129 15.1397 11.129 14.5161C11.129 13.8926 10.6235 13.3871 10 13.3871Z' fill='%23991B1B'/%3E%3C/svg%3E");
    background-size:100%;
  }

.form-item__description {
  margin-top: 0.75rem;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  color: var(--gray-professional-lighten-1);
}

.form-item--order-first {
  order: -9999;
}

.form-item--order-second{
  order:-2;
}

.exposed-form {
  flex-wrap: wrap !important;
  border-radius: 0.75rem !important;
  padding-left: 1.75rem !important;
  padding-right: 1.75rem !important;
  padding-top: 1.75rem !important;
}

.exposed-form.shadow{
    box-shadow:var(--brand-shadow);
  }

.exposed-form .form-item:first-child {
  width: 100%;
}

.exposed-form .form-item:first-child input {
  width: 100%;
}

.exposed-form [type='submit']:hover {
  cursor: pointer;
}

.exposed-form [type='submit']{

    background-color:var(--outline-btn--primary-bg-color-default);
    color:var(--outline-btn--primary-text-color-default);
    border:var(--outline-btn--primary-border-default);
    outline:var(--outline-btn--primary-outline-default);
    font-weight:var(--outline-btn--primary-weight-default);
  }

.exposed-form [type='submit']:hover{
      background-color:var(--outline-btn--primary-bg-color-hover);
      color:var(--outline-btn--primary-text-color-hover);
      border:var(--outline-btn--primary-border-hover);
      outline:var(--outline-btn--primary-outline-hover);
      font-weight:var(--outline-btn--primary-weight-hover);
    }

.exposed-form [type='submit']:focus{
      background-color:var(--outline-btn--primary-bg-color-focus);
      color:var(--outline-btn--primary-text-color-focus);
      border:var(--outline-btn--primary-border-focus);
      outline:var(--outline-btn--primary-outline-focus);
      font-weight:var(--outline-btn--primary-weight-focus);
    }

.exposed-form [type='submit'].secondary{
      padding:var(--outline-btn--secondary-padding);
      border-radius:var(--outline-btn--secondary-rounded);
      background-color:var(--outline-btn--secondary-bg-color-default);
      color:var(--outline-btn--secondary-text-color-default);
      border:var(--outline-btn--secondary-border-default);
      outline:var(--outline-btn--secondary-outline-default);
      font-weight:var(--outline-btn--secondary-weight-default);
    }

.exposed-form [type='submit'].secondary:hover{
        background-color:var(--outline-btn--secondary-bg-color-hover);
        color:var(--outline-btn--secondary-text-color-hover);
        border:var(--outline-btn--secondary-border-hover);
        outline:var(--outline-btn--secondary-outline-hover);
        font-weight:var(--outline-btn--secondary-weight-hover);
      }

.exposed-form [type='submit'].secondary:focus{
        background-color:var(--outline-btn--secondary-bg-color-focus);
        color:var(--outline-btn--secondary-text-color-focus);
        border:var(--outline-btn--secondary-border-focus);
        outline:var(--outline-btn--secondary-outline-focus);
        font-weight:var(--outline-btn--secondary-weight-focus);
      }

.idb-search-project.inline {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
}

@media (min-width: 768px) {

  .idb-search-project.inline {
    flex-wrap: nowrap;
  }
}

.idb-search-project.inline .form-item {
  width: 55%;
}

@media (min-width: 768px) {

  .idb-search-project.inline .form-item {
    margin-right: 1.75rem;
  }
}

.idb-search-project.inline .form-item input[type='text'] {
  width: 100%;
}

.idb-search-project.inline .form-item .form-submit {
  width: 100%;
}

input[type='date'], input[type='text'], select {
  width: 100%;
}

input[type='date'] {
  position: relative;
}

input[type='date']::-webkit-calendar-picker-indicator {
  position: absolute;
  top: 0px;
  right: 0px;
  margin-right: 0.75rem;
}

.chosen-container {
  width: 100% !important;
  background-repeat: no-repeat;
  padding-right: 3.5rem;
  background-position:top 6px right 12px;
  background-image:url("data:image/svg+xml,%3Csvg width='15' height='8' viewBox='0 0 15 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.81303 7.83121L14.6455 0.979811C14.8692 0.755333 14.8688 0.391897 14.6443 0.167795C14.4198 -0.0561333 14.0562 -0.0555547 13.8323 0.168952L7.40651 6.61254L0.980746 0.16872C0.756818 -0.0557579 0.393412 -0.0563366 0.168904 0.167563C0.0563612 0.279903 8.96267e-05 0.427077 8.96203e-05 0.574251C8.96139e-05 0.721049 0.0559854 0.867644 0.167747 0.979782L7.00003 7.83121C7.10759 7.93933 7.25399 8 7.40651 8C7.55904 8 7.70526 7.93916 7.81303 7.83121Z' fill='%231B365D'/%3E%3C/svg%3E");
}

.chosen-container-single .chosen-single {
  height: 2.5rem;
  border-width: 0px;
  background-image: none;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-family: Open Sans, Helvetica, Arial, sans-serif;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  font-weight: var(--fw-normal);
  line-height: 1.25rem;
  color: var(--blue-responsible-darken-1);
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.chosen-container-single .chosen-single div {
  display: none;
}

.chosen-container .chosen-drop {
  border-width: 0px;
}

.chosen-container .chosen-results li {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-family: Open Sans, Helvetica, Arial, sans-serif;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
}

.chosen-container .chosen-results li.highlighted{
  background:none;
  background-color: var(--blue-responsible-main);
}

.chosen-container-active.chosen-with-drop .chosen-single {
  border-width: 0px;
  background-image: none;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.chosen-container-single .chosen-search input[type='text'] {
  background-image: none;
  font-family: Open Sans, Helvetica, Arial, sans-serif;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z' stroke='%23004E70' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M19 19L14.65 14.65' stroke='%23004E70' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
  background-repeat:no-repeat !important;
  background-position:right -20px !important;
  background-size:20px auto !important;
  padding:4px 40px 4px 5px;
}

.chosen-container.chosen-with-drop {
  background-color: var(--neutral-white);
}

.form-no-label input[type='text'],
  .form-no-label select{
    padding-top:22px !important;
    padding-bottom:22px !important;
  }

.form-no-label select{
    background-position:right 12px center;
  }

:host([style-bordered]) .form-item {
  border-width: 1px;
}

:host([style-bordered]) .form-item {
  border-style: solid;
}

:host([style-bordered]) .form-item {
  border-color: var(--gray-professional-lighten-2);
}

.steps-wrapper {
  padding-bottom: 3.5rem;
}

.steps-wrapper .steps {
  position: relative;
}

.steps-wrapper .steps {
  display: flex;
}

.steps-wrapper .steps {
  place-content: space-around;
}

.steps-wrapper .steps:before{
      content:'';
    }

.steps-wrapper .steps:before {
  top: 50%;
}

.steps-wrapper .steps:before {
  margin-top: -2;
}

.steps-wrapper .steps:before {
  height: 3px;
}

.steps-wrapper .steps:before {
  position: absolute;
}

.steps-wrapper .steps:before {
  width: 50%;
}

.steps-wrapper .steps:before {
  background-color: var(--gray-professional-lighten-3);
}

.steps-wrapper .steps .step {
  display: flex;
}

.steps-wrapper .steps .step {
  height: 50px;
}

.steps-wrapper .steps .step {
  width: 50px;
}

.steps-wrapper .steps .step {
  align-items: center;
}

.steps-wrapper .steps .step {
  justify-content: center;
}

.steps-wrapper .steps .step {
  z-index: 10;
}

.steps-wrapper .steps .step {
  border-radius: 9999px;
}

.steps-wrapper .steps .step {
  border-width: 2px;
}

.steps-wrapper .steps .step {
  border-color: var(--green-guarantee-main);
}

.steps-wrapper .steps .step {
  background-color: var(--outline-white);
}

.steps-wrapper .steps .step {
  font-size: var(--fs-2xl);
  line-height: var(--lh-2xl);
}

.steps-wrapper .steps .step {
  color: var(--green-guarantee-main);
}

.steps-wrapper .steps .step {
  outline-style: solid;
}

.steps-wrapper .steps .step {
  outline-width: 8px;
}

.steps-wrapper .steps .step {
  outline-color: var(--outline-white);
}

.steps-wrapper .steps .step .step-label {
  position: absolute;
}

.steps-wrapper .steps .step .step-label {
  bottom: -3rem;
}

.steps-wrapper .steps .step .step-label {
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
}

.steps-wrapper .steps .step .step-label {
  font-weight: var(--fw-light);
}

.steps-wrapper .steps .step .step-label {
  color: var(--gray-professional-main);
}

.steps-wrapper .steps .step--active, .steps-wrapper .steps .step--past {
  background-color: var(--green-guarantee-main);
}

.steps-wrapper .steps .step--active, .steps-wrapper .steps .step--past {
  color: var(--outline-white);
}

.steps-wrapper .steps .step--active .step-label, .steps-wrapper .steps .step--past .step-label {
  font-weight: var(--fw-semibold);
}

.steps-wrapper .steps .step--past{
        background-image:url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
        background-repeat:no-repeat;
        background-position:center;
      }

.steps-wrapper .steps .step--past .step-number {
  display: none;
}

.steps-wrapper .steps .step--past .step-label {
  font-weight: var(--fw-light);
}

input:focus, select:focus, textarea:focus {
  border-width: 2px;
}

.indicator {
  margin-top: 1rem;
  display: flex;
  width: 100%;
  justify-content: flex-end;
  padding-left: 1.75rem;
  padding-right: 1.75rem;
  font-weight: var(--fw-light);
}

.indicator:before{
    content:'*';
  }

.indicator:before {
  margin-right: 0.25rem;
}

.indicator:before {
  color: var(--ui-warningText);
}

:host([style-label-outside]) label {
  margin-bottom: 0.5rem;
}

:host([style-label-outside]) label {
  padding-left: 0px;
  padding-right: 0px;
}

:host([style-label-outside]) label {
  font-size: var(--fs-base);
  line-height: var(--lh-base);
}

:host([style-label-outside]) label {
  font-weight: var(--fw-light);
}

:host([style-label-outside]) label {
  text-transform: none;
}

:host([style-label-outside]) label {
  color: var(--blue-responsible-darken-1);
}

:host([style-label-outside]) label:after {
  float: none;
}

:host([style-label-outside]) label:after {
  margin-left: 0.25rem;
}

:host([style-label-outside]) label:after {
  color: var(--cyan-near-main);
}

:host([style-label-outside]) input, :host([style-label-outside]) select, :host([style-label-outside]) textarea, :host([style-label-outside]) .form-select {
  border-radius: 0.5rem;
}

:host([style-label-outside]) input, :host([style-label-outside]) select, :host([style-label-outside]) textarea, :host([style-label-outside]) .form-select {
  border-width: 1px;
}

:host([style-label-outside]) input, :host([style-label-outside]) select, :host([style-label-outside]) textarea, :host([style-label-outside]) .form-select {
  border-color: var(--gray-professional-lighten-2);
}

:host([style-label-outside]) input, :host([style-label-outside]) select, :host([style-label-outside]) textarea, :host([style-label-outside]) .form-select {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

:host([style-label-outside]) input:focus, :host([style-label-outside]) select:focus, :host([style-label-outside]) textarea:focus, :host([style-label-outside]) .form-select:focus {
  border-color: var(--blue-responsible-main);
}

:host([style-label-outside]) select{
    background-position:top 22px right 12px;
  }

:host([style-label-outside]) .chosen-container.form-select{
    background-position:right 12px top 22px;
  }

:host([style-label-outside]) .chosen-container.chosen-with-drop{
    border-bottom-right-radius:0;
    border-bottom-left-radius:0;
  }

:host([style-label-outside]) .indicator {
  margin-top: 2rem;
}

@media (min-width: 1024px) {

  :host([style-label-outside]) .indicator {
    margin-top: 2.5rem;
  }
}

:host([style-label-outside]) .indicator:before {
  color: var(--cyan-near-main);
}

:host([style-label-outside]) .chosen-container {
  padding: 0px;
}

:host([style-label-outside]) .chosen-container{
    background-position-y:20px;
  }

:host([style-label-outside]) .chosen-container a {
  height: auto;
}

:host([style-label-outside]) .chosen-container a {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.text-wrapper {
  text-align: center;
}

.text-wrapper idb-heading {
  margin-top: 2rem;
}

@media (min-width: 1024px) {

  .text-wrapper idb-heading {
    margin-top: 2.5rem;
  }
}

.text-wrapper idb-styled-text {
  margin-top: 2rem;
}

.text-wrapper idb-styled-text {
  font-weight: var(--fw-normal);
}

.text-wrapper idb-styled-text {
  color: var(--gray-professional-lighten-1);
}

.idb-sanctions-form input[type='text'], .idb-sanctions-form select {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.switch {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: flex-end;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  text-transform: none;
  color: var(--blue-responsible-darken-1);
}

.switch div {
  position: relative;
  display: inline-block;
  background-color: var(--outline-transparent);
  width:55px;
  height:30px;
  margin-right:10px;
}

.switch input {
  height: 0px;
  width: 0px;
  opacity: 0;
}

.slider {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  cursor: pointer;
  background-color: var(--gray-professional-lighten-2);
  transition:0.4s;
  height:24px;
  width:50px;
  border-radius:34px;
}

.slider:before {
  position: absolute;
  left: 0px;
  background-color: var(--outline-white);
  content:'';
  top:-3px;
  height:30px;
  width:30px;
  transition:0.4s;
  border:2px solid var(--gray-professional-lighten-2);
  border-radius:50%;
}

input:checked + .slider {
  background-color: var(--blue-responsible-main);
}

input:focus + .slider{
  box-shadow:0 0 1px var(--blue-responsible-main);
}

input:checked + .slider:before{
  transform:translateX(20px);
  border-color:var(--blue-responsible-main);
}
`;